module.exports = __webpack_public_path__ + "fonts/Poppins-Medium.563f976.woff2";